import React, {useState} from 'react';

import Button from '../../elements/Button';
import Input from '../../elements/Input';
import Text from '../../elements/Text';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {BUTTON_TYPES, RELATION_OPTIONS} from '../../../utils/Constants';
import DropdownButton from '../../elements/DropdownButton';
import DropdownOptionsDrawer from '../DropdownOptionsDrawer';
import {Platform, View} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';

const EditContactForm = ({
  firstName,
  lastName,
  phoneNo,
  email,
  setFirstName,
  setLastName,
  setPhoneNo,
  setEmail,
  setRelationship,
  relationship,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const relationOptions = Object.values(RELATION_OPTIONS);
  const [selectedIndex, setSelectedIndex] = useState(
    relationOptions.indexOf(relationship),
  );
  const [visible, setvisible] = useState(false);

  return (
    <>
      <Text
        testID={tID('EditContactForm-Text-PersonalDetails')}
        variation="Headline4SemiBold22"
        color={colors.textHeading}>
        Personal Details
      </Text>
      <Input
        testID={tID('EditContactForm-Input-FirstName')}
        // hasError={hasError}
        placeholder={'Type here...'}
        inputTitle={'First Name'}
        topMargin={24}
        value={firstName}
        onChangeText={setFirstName}
        autoCapitalize="words"
        textContentType="givenName"
        autoComplete="given-name"
      />
      <Input
        testID={tID('EditContactForm-Input-LastName')}
        // hasError={hasError}
        placeholder={'Type here...'}
        inputTitle={'Last Name'}
        topMargin={24}
        value={lastName}
        onChangeText={setLastName}
        autoCapitalize="words"
        textContentType="familyName"
        autoComplete="family-name"
      />
      <DropdownButton
        // hasError={hasError}
        placeholder={'Select...'}
        inputTitle={'Relationship'}
        topMargin={24}
        value={relationship}
        onPress={() => setvisible(!visible)}
      />
      <Text
        testID={tID('EditContactForm-Text-ContactInfo')}
        variation="Headline4SemiBold22"
        topMargin={24}
        color={colors.textHeading}>
        Contact Info
      </Text>
      <Input
        testID={tID('EditContactForm-Input-PhoneNumber')}
        placeholder={'Type here...'}
        inputTitle={'Phone Number'}
        topMargin={24}
        value={phoneNo}
        onChangeText={setPhoneNo}
        maxLength={10}
        keyboardType={'number-pad'}
        textContentType="telephoneNumber"
        autoComplete="tel"
      />
      <Input
        testID={tID('EditContactForm-Input-Email')}
        // hasError={hasError}
        placeholder={'Type here...'}
        inputTitle={'Email'}
        topMargin={24}
        value={email}
        onChangeText={setEmail}
        keyboardType={'email-address'}
        autoCapitalize="none"
        autoCorrect={false}
        textContentType="emailAddress"
        autoComplete="email"
      />
      <DropdownOptionsDrawer
        options={relationOptions}
        visible={visible}
        title="Relationship"
        selectedOptions={[relationship]}
        containerStyle={Platform.OS === 'web' && styles.relationDropdownModal}
        buttons={[
          {
            title: 'Cancel',
            buttonType: BUTTON_TYPES.Bordered,
            onPress: () => {
              setvisible(!visible);
            },
          },
          {
            title: 'Confirm',
            buttonType: BUTTON_TYPES.Filled,
            onPress: selected => {
              setvisible(!visible);
              if (selected.length > 0) {
                setRelationship(selected[0]);
              }
            },
          },
        ]}
      />
    </>
  );
};

export default EditContactForm;
